<!--
 * @Description: 申请转有效弹窗组件
 * @Author: mdb
 * @Date: 2022-07-13 17:08:55
 * @LastEditTime: 2022-07-28 11:37:49
 * @LastEditors: mdb
-->
<template>
  <a-modal
    v-model:visible="visible"
    title="申请转有效"
    :body-style="{ padding: '30px' }"
    :confirm-loading="loading"
    @ok="handleBecomeValidOk"
    @cancel="handleBecomeValidCancel"
  >
    <a-form :wrapper-col="{ span: 24 }">
      <a-form-item label="申请原因" v-bind="validateInfos.applyReason">
        <a-textarea v-model:value="dataForm.applyReason" :maxlength="2000" placeholder="请输入" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'
import { Form } from 'ant-design-vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { salesClueChangeValid } from '@/api/gucangSales/clueManage'
import type { SalesClueListItem } from '@/typings/api/clueManage'

const useForm = Form.useForm
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<SalesClueListItem[]>([])
const dataForm = reactive<{ applyReason: string; clueIdList: any[] }>({ applyReason: '', clueIdList: [] })
const formRules = reactive({
  applyReason: [{ required: true, message: '请填写申请原因' }]
})
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)

const init = (data: SalesClueListItem[]) => {
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['fetch'])
const handleBecomeValidOk = () => {
  validate().then(() => {
    loading.value = true
    dataForm.clueIdList = selectedData.value.map((item: SalesClueListItem) => item.clueId)
    const params = Object.assign({}, dataForm)
    salesClueChangeValid(params)
      .then(() => {
        DcMessage.success('申请转有效成功')
        resetFields()
        visible.value = false
        emit('fetch')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const handleBecomeValidCancel = () => {
  resetFields()
}

defineExpose({ init })
</script>
<script lang="ts">
export default { name: 'BecomeValid' }
</script>

<style scoped></style>
